import React from 'react';
import { useSelector } from 'react-redux';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { format, isToday } from 'date-fns';
import {
  Typography,
  Card,
  Divider
} from '@material-ui/core';
import { BackdropCircular } from 'components';


const FutureTasks = () => {
  const { futureAssignedTasks, isLoading } = useSelector((state: IReduxState) => state.home);
  const { profile } = useSelector((state: IReduxState) => state.user);

  return (
    <>
      {futureAssignedTasks.length > 0 && (
        <Card elevation={3} className="m-5 p-5">
          <div className="flex justify-between">
            <div className="flex mb-1">
              <AssignmentIcon color="primary" fontSize="small" />
              <Typography className="text-gray ml-1" variant="h5">
                Hi, {profile.firstName}! Here are your tasks for today
              </Typography>
            </div>
          </div>
          <Divider />
          {futureAssignedTasks.map((task) => (
            <div key={task._id}>
              <div className="flex justify-between my-2">
                <Typography className="text-muted" variant="subtitle1">
                  <span className="capitalize">{task.type}</span>: {task.subject}
                  {task.patientFirstName ? ` to ${task.patientFirstName} ${task.patientLastName}` : ''}
                </Typography>
                <Typography className="text-muted" variant="subtitle1">
                  {isToday(new Date(task.dueDateTime))
                    ? 'Today'
                    : format(new Date(task.dueDateTime), 'MMM dd')}
                </Typography>
              </div>
              <Divider />
            </div>
          ))}
          <BackdropCircular loading={isLoading} />
        </Card>
      )}
    </>
  );
};

export default FutureTasks;
